import { GlobalWorkerOptions, getDocument } from "pdfjs-dist";
import { normalizeDocumentDataUrl } from "../services/Functions";

const PDFJS_WORKER_CDN =
  "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.0.379/pdf.worker.min.mjs";

const decodePdfBytes = (src) => {
  const normalized = normalizeDocumentDataUrl(src) || String(src || "");
  if (!normalized) return null;

  let body = normalized.includes(",")
    ? normalized.slice(normalized.indexOf(",") + 1)
    : normalized.replace(/^data:[^;]+;base64,/i, "");

  body = body
    .replace(/\s/g, "")
    .replace(/-/g, "+")
    .replace(/_/g, "/");
  if (body.startsWith("77u/")) body = body.slice(4);
  if (!body) return null;
  while (body.length % 4 !== 0) body += "=";

  const binary = atob(body);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
};

const renderPdfPages = async (bytes) => {
  const pdf = await getDocument({ data: bytes }).promise;
  const images = [];
  const maxPages = Math.min(pdf.numPages || 0, 8);
  for (let pageNo = 1; pageNo <= maxPages; pageNo += 1) {
    const page = await pdf.getPage(pageNo);
    const viewport = page.getViewport({ scale: 1.6 });
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    canvas.height = viewport.height;
    canvas.width = viewport.width;
    await page.render({ canvasContext: context, viewport }).promise;
    images.push(canvas.toDataURL("image/png"));
  }
  return images;
};

/** Convert a PDF (data URL / raw base64) into PNG data URLs, one per page. */
export const pdfToImages = async (src) => {
  try {
    const bytes = decodePdfBytes(src);
    if (!bytes || !bytes.length) return [];

    GlobalWorkerOptions.workerSrc = PDFJS_WORKER_CDN;
    return await renderPdfPages(bytes);
  } catch (e) {
    return [];
  }
};

export default pdfToImages;
